import { ICapsuleData } from './type.d';

export const getMaxValue = (data: ICapsuleData[], coefficient = 1) => {
  // Filter out null/undefined values before calculating max
  const values = data
    .filter(p => p.value !== null && p.value !== undefined)
    .map(p => Math.abs(p.value));
  
  // If no valid values, return 0 to avoid NaN
  if (values.length === 0) {
    return 0;
  }
  
  const max = Math.max(...values);
  const result = max * coefficient;
  return result;
};

/**
 * 根据胶囊数据项生成显示标题
 * 
 * @param item 胶囊数据项，包含标题、格式化值、比率等属性
 * @returns 格式化后的标题字符串。若指定了displayTitleFormat则按格式拼接，否则返回默认格式"标题: 值 (比率%)"
 */
export const getTitle = (item: ICapsuleData, localeTitle?: string) => {
  const { title, formattedValue, rate, displayTitleFormat, unit, showRate = true } = item;
  if (displayTitleFormat === 'none') {
    return '';
  }
  if (displayTitleFormat) {
    let str = '';
    displayTitleFormat.split(',').forEach((titleStr: string) => {
      if (titleStr === 'title' && localeTitle) {
        str += `${localeTitle}`;
      } else if (titleStr === 'rate') {
        // Special handling for rate: check for undefined/null/NaN/Infinity
        const rateValue = item?.rate;
        if (rateValue !== undefined && rateValue !== null && !isNaN(rateValue) && isFinite(rateValue)) {
          str += `${rateValue}`;
        } else {
          str += '-';
        }
      } else {
        // 传入的可能会有一些特殊符号，例如:或者(),直接使用
        str += `${item?.[titleStr] || titleStr}`;
      }
    });
    return str;
  }
  // Handle undefined/null/NaN/Infinity rate (when KPI is 0) - show '-' instead of 'undefined%'
  const rateDisplay = rate !== undefined && rate !== null && !isNaN(rate) && isFinite(rate) ? `${rate}` : '-';
  // 根据 showRate 参数决定是否显示百分比
  const ratePart = showRate ? ` (${rateDisplay}%)` : '';
  return `${localeTitle || title}: ${unit === undefined ? '$' : unit}${formattedValue}${ratePart}`;
};

export const getDataDirectionType = (data: ICapsuleData[], totalData: ICapsuleData) => {
  // Filter out null/undefined values — they have no meaningful direction
  const validData = data.filter(p => p.value !== null && p.value !== undefined);
  
  let allPositive = null;
  let totalValuePositive = null;

  if (validData.length === 0) {
    // No valid pillar data — treat as positive (default, 0M at left)
    allPositive = true;
  } else if (validData.every(p => p.value < 0)) {
    allPositive = false;
  } else if (validData.every(p => p.value >= 0)) {
    allPositive = true;
  }
  // allPositive remains null only when validData has genuinely mixed signs

  if (totalData && totalData.value !== null && totalData.value !== undefined) {
    if (totalData.value < 0) {
      totalValuePositive = false;
    } else {
      totalValuePositive = true;
    }
  } else {
    // No valid totalData — default to positive
    totalValuePositive = true;
  }

  // Pillars have genuinely mixed signs (some positive, some negative)
  if (allPositive === null) {
    return 'mixed';
  }
  if (allPositive === true && totalValuePositive === true) {
    return 'positive';
  } 
  if (allPositive === false && totalValuePositive === false) {
    return 'negative';
  }
  return 'mixed';
};